import canUseDom from "rc-util/es/Dom/canUseDom";
import { isStyleSupport } from "rc-util/es/Dom/styleChecker";
export const canUseDocElement = () => canUseDom() && window.document.documentElement;
export { isStyleSupport };


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/styleChecker.js
// module id = 1004
// module chunks = 0